
import type { Contact } from "../../types/contacts";
import { apiClient } from "../core/apiClient";

interface getContactResult {
  contacts: Contact[];
  pagination: {
    page: number,
    limit: number,
    total: number,
    pages: number
  }
}

interface results<T = any> {
  data: T
}

export class ContactService {

  async getContacts(params?: { page?: number }): Promise<getContactResult> {
    const queryString = params ? new URLSearchParams(params as any).toString() : '';

    const endpoint = `/contacts${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<getContactResult>(endpoint, { timeout: 50000 });
    return response.data;
  }

  async getContactsbyId(id: number): Promise<results> {
    const endpoint = `/leads/${id}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

}

export const contactService = new ContactService();